import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-faaa0fde")

_pushScopeId("data-v-faaa0fde")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Menu")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Presenze")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Documenti")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Richieste")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Banca ore")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Automezzi")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Note spesa")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Rimborsi km")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Interventi")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Tickets")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Clienti")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Progetti")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Leads")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Sondaggi")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Profilo")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Versione 2.7")
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "logo_ingegno" }, [
  /*#__PURE__*/_createVNode("img", { src: "assets/logo_ingegno.png" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_ion_list = _resolveComponent("ion-list")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_menu = _resolveComponent("ion-menu")

  return (_openBlock(), _createBlock(_component_ion_menu, {
    "menu-id": "app-menu",
    "content-id": "main-content"
  }, {
    default: _withId(() => [
      _createVNode(_component_ion_header, null, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withId(() => [
          _createVNode(_component_ion_list, { lines: "none" }, {
            default: _withId(() => [
              (_ctx.$showPresenze === 'true')
                ? (_openBlock(), _createBlock(_component_ion_item, {
                    key: 0,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.changePage('presenze'))),
                    class: "menu_border_bottom"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.time,
                        slot: "start"
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, { class: "menu_title" }, {
                        default: _withId(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.$showDocumenti === 'true')
                ? (_openBlock(), _createBlock(_component_ion_item, {
                    key: 1,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.changePage('documenti'))),
                    class: "menu_border_bottom"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.documents,
                        slot: "start"
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, { class: "menu_title" }, {
                        default: _withId(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.$showRichieste === 'true')
                ? (_openBlock(), _createBlock(_component_ion_item, {
                    key: 2,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.changePage('richieste'))),
                    class: "menu_border_bottom"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.clipboard,
                        slot: "start"
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, { class: "menu_title" }, {
                        default: _withId(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.$showBancaOre === 'true')
                ? (_openBlock(), _createBlock(_component_ion_item, {
                    key: 3,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.changePage('banca'))),
                    class: "menu_border_bottom"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.hourglass,
                        slot: "start"
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, { class: "menu_title" }, {
                        default: _withId(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.$showAutomezzi === 'true')
                ? (_openBlock(), _createBlock(_component_ion_item, {
                    key: 4,
                    onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.changePage('automezzi'))),
                    class: "menu_border_bottom"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.car,
                        slot: "start"
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, { class: "menu_title" }, {
                        default: _withId(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.$showNoteSpesa === 'true')
                ? (_openBlock(), _createBlock(_component_ion_item, {
                    key: 5,
                    onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.changePage('spese'))),
                    class: "menu_border_bottom"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.wallet,
                        slot: "start"
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, { class: "menu_title" }, {
                        default: _withId(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.$showRimborsi === 'true')
                ? (_openBlock(), _createBlock(_component_ion_item, {
                    key: 6,
                    onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.changePage('rimborsi'))),
                    class: "menu_border_bottom"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.card,
                        slot: "start"
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, { class: "menu_title" }, {
                        default: _withId(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.$showInterventi === 'true')
                ? (_openBlock(), _createBlock(_component_ion_item, {
                    key: 7,
                    onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.changePage('interventi'))),
                    class: "menu_border_bottom"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.documentText,
                        slot: "start"
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, { class: "menu_title" }, {
                        default: _withId(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.$showTickets === 'true')
                ? (_openBlock(), _createBlock(_component_ion_item, {
                    key: 8,
                    onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.changePage('tickets'))),
                    class: "menu_border_bottom"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.ticket,
                        slot: "start"
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, { class: "menu_title" }, {
                        default: _withId(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.$showClienti === 'true')
                ? (_openBlock(), _createBlock(_component_ion_item, {
                    key: 9,
                    onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.changePage('clienti'))),
                    class: "menu_border_bottom"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.people,
                        slot: "start"
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, { class: "menu_title" }, {
                        default: _withId(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.$showProgetti === 'true')
                ? (_openBlock(), _createBlock(_component_ion_item, {
                    key: 10,
                    onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.changePage('progetti'))),
                    class: "menu_border_bottom"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.listCircle,
                        slot: "start"
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, { class: "menu_title" }, {
                        default: _withId(() => [
                          _hoisted_12
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.$showLeads === 'true')
                ? (_openBlock(), _createBlock(_component_ion_item, {
                    key: 11,
                    onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.changePage('leads'))),
                    class: "menu_border_bottom"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.book,
                        slot: "start"
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, { class: "menu_title" }, {
                        default: _withId(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.$showSondaggi === 'true')
                ? (_openBlock(), _createBlock(_component_ion_item, {
                    key: 12,
                    onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.changePage('sondaggi'))),
                    class: "menu_border_bottom"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.newspaper,
                        slot: "start"
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, { class: "menu_title" }, {
                        default: _withId(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.$showProfilo === 'true')
                ? (_openBlock(), _createBlock(_component_ion_item, {
                    key: 13,
                    onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.changePage('profilo'))),
                    class: "menu_border_bottom"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.person,
                        slot: "start"
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, { class: "menu_title" }, {
                        default: _withId(() => [
                          _hoisted_15
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_ion_item, null, {
                default: _withId(() => [
                  _createVNode(_component_ion_icon, {
                    icon: $setup.informationCircle,
                    slot: "start"
                  }, null, 8, ["icon"]),
                  _createVNode(_component_ion_label, { class: "menu_title" }, {
                    default: _withId(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _hoisted_17
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})